import { Box, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Typography } from "@mui/material";
import { ColumnData, currencyOf, resolveWrapper } from "utils/util";
import { FlowConsignadoVisualizarAbaProdutosDTO, FlowConsignadoVisualizarItemDTO } from "../consignado-visualizar-dialog.model";

export const AbaProduto = (props: { data: FlowConsignadoVisualizarAbaProdutosDTO; }) => {

    const _columnsItens: ColumnData<FlowConsignadoVisualizarItemDTO>[] = [
        {
            header: 'SKU',
            id: 'sku',
            key: 'descritivo',
            width: 30,
        },

        // {
        //     header: 'Situação',
        //     id: 'situacao',
        //     key: 'situacao',
        //     textAlign: 'center',
        //     width: 6.36,
        // },

        {
            header: 'Valor unitário',
            id: 'valor-unit',
            key: 'valorUnitario',
            textAlign: 'center',
            width: 6.36,
            convert: item => {
                return <>{currencyOf(item.valorUnitario)}</>;
            },
        },

        {
            header: '% desconto',
            id: 'percentual-desconto',
            key: 'percentualDesconto',
            textAlign: 'center',
            width: 6.36,
            convert: item => {
                return <>{item.percentualDesconto}%</>;
            },
        },

        {
            header: 'Valor de desconto',
            id: 'valor-desconto',
            key: 'valorDesconto',
            textAlign: 'center',
            width: 6.36,
            convert: item => {
                return <>{currencyOf(item.valorDesconto)}</>;
            },
        },

        {
            header: 'Valor total',
            id: 'valor-total',
            key: 'valorTotalLiquido',
            textAlign: 'center',
            width: 6.36,
            convert: item => {
                return <>{currencyOf(item.valorTotalLiquido)}</>;
            },
        },

        {
            header: 'Quantidade aberta',
            id: 'quantidade-aberta',
            key: 'quantidadeAberta',
            textAlign: 'center',
            width: 6.36,
        },

        {
            header: 'Quantidade consignada',
            id: 'quantidade-consignada',
            key: 'quantidadeConsignada',
            textAlign: 'center',
            width: 6.36,
        },

        {
            header: 'Quantidade devolvida',
            id: 'quantidade-devolvida',
            key: 'quantidadeDevolvida',
            textAlign: 'center',
            width: 6.36,
        },

        {
            header: 'Quantidade vendida',
            id: 'quantidade-vendida',
            key: 'quantidadeVendida',
            textAlign: 'center',
            width: 6.36,
        },

        {
            header: 'Quantidade cancelada',
            id: 'quantidade-cancelada',
            key: 'quantidadeCancelada',
            textAlign: 'center',
            width: 6.36,
        },

        {
            header: 'Saldo',
            id: 'saldo',
            key: 'saldo',
            textAlign: 'center',
            width: 6.36,
        },
    ];

    return <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px'
        }}
    >

        <Table size='small'>
            <TableHead>
                <TableRow>
                    {_columnsItens.map(c => <TableCell key={c.id} width={`${c.width}%`}>
                        <Typography align={c.textAlign} fontWeight={'bold'}>
                            {c.header}
                        </Typography>
                    </TableCell>
                    )}
                </TableRow>
            </TableHead>

            <TableBody>
                {props.data.itens.map((item, index) => {
                    return <TableRow key={index}>
                        {_columnsItens.map(c => <TableCell key={c.id}>
                            <Typography align={c.textAlign}>
                                {c.convert?.(item, { column: c }) ?? resolveWrapper(item, c.key)}
                            </Typography>
                        </TableCell>
                        )}
                    </TableRow>;
                })}
            </TableBody>

            <TableFooter>
                <TableRow >
                    <TableCell colSpan={4}>
                        <Typography fontWeight={'bold'}>
                            {props.data.quantidadeProdutos}
                        </Typography>
                    </TableCell>

                    <TableCell>
                        <Typography textAlign={'center'} fontWeight={'bold'}>
                            {currencyOf(props.data.valorTotal)}
                        </Typography>
                    </TableCell>

                    <TableCell>
                        <Typography textAlign={'center'} fontWeight={'bold'}>
                            {props.data.quantidadeAberta}
                        </Typography>
                    </TableCell>

                    <TableCell>
                        <Typography textAlign={'center'} fontWeight={'bold'}>
                            {props.data.quantidadeConsignada}
                        </Typography>
                    </TableCell>

                    <TableCell>
                        <Typography textAlign={'center'} fontWeight={'bold'}>
                            {props.data.quantidadeDevolvida}
                        </Typography>
                    </TableCell>

                    <TableCell>
                        <Typography textAlign={'center'} fontWeight={'bold'}>
                            {props.data.quantidadeVendida}
                        </Typography>
                    </TableCell>

                    <TableCell>
                        <Typography textAlign={'center'} fontWeight={'bold'}>
                            {props.data.quantidadeCancelada}
                        </Typography>
                    </TableCell>

                    <TableCell>
                        <Typography textAlign={'center'} fontWeight={'bold'}>
                            {props.data.saldo}
                        </Typography>
                    </TableCell>
                </TableRow>
            </TableFooter>
        </Table>
    </Box>;
};
